/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Users_Ip_ColInputs */

const en_admin_users_ip_col = /** @type {(inputs: Admin_Users_Ip_ColInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign-up IP`)
};

/**
* | output |
* | --- |
* | "Sign-up IP" |
*
* @param {Admin_Users_Ip_ColInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_users_ip_col = /** @type {((inputs?: Admin_Users_Ip_ColInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Users_Ip_ColInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_users_ip_col(inputs)
});
export { admin_users_ip_col as "admin.users.ip_col" }